import { Factory } from 'rosie';

const teamId = 'example-team-id';

Factory.define('TeamEditor').attr('name', 'TEAM_EDITOR');

Factory.define('TeamEditorWithDefaults')
  .extend('TeamEditor')
  .attr('teamId', teamId);



// WEBPACK FOOTER //
// ./factories/location/team_editor.js